import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useRef, useState } from 'react';
import { Menu, MenuRow, useId } from '@applyboard/ui-components';
import FontAwesome from 'react-fontawesome';
import { IconButton } from "../../style/buttons";
var NoteTemplateOptionsMenu = function NoteTemplateOptionsMenu(_ref) {
  var archiveLabel = _ref.archiveLabel,
    deleteLabel = _ref.deleteLabel,
    onArchive = _ref.onArchive,
    onDelete = _ref.onDelete;
  var buttonRef = useRef(null);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    menuOpen = _useState2[0],
    setMenuOpen = _useState2[1];
  var handleArchive = onArchive ? function (a, b, event) {
    if (event !== null && event !== void 0 && event.preventDefault) event.preventDefault();
    if (event !== null && event !== void 0 && event.stopPropagation) event.stopPropagation();
    setMenuOpen(false);
    onArchive(event);
  } : null;
  var handleDelete = onDelete ? function (a, b, event) {
    if (event !== null && event !== void 0 && event.preventDefault) event.preventDefault();
    if (event !== null && event !== void 0 && event.stopPropagation) event.stopPropagation();
    setMenuOpen(false);
    onDelete(event);
  } : null;
  var handleMenuOpen = function handleMenuOpen(event) {
    event.preventDefault();
    event.stopPropagation();
    setMenuOpen(true);
  };
  var id = useId();
  var controlsMenuId = "note-template-menu-".concat(id);
  if (!onDelete && !onArchive) return null;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(IconButton, {
    "aria-controls": controlsMenuId,
    "aria-haspopup": "true",
    "aria-label": "actions",
    "aria-pressed": menuOpen,
    onClick: handleMenuOpen,
    ref: buttonRef,
    secondary: true,
    style: {
      padding: '6px 4px'
    }
  }, /*#__PURE__*/React.createElement(FontAwesome, {
    name: "ellipsis-v",
    "aria-hidden": "true"
  })), /*#__PURE__*/React.createElement(Menu, {
    anchorRef: buttonRef,
    id: controlsMenuId,
    open: menuOpen,
    placement: "bottom-end",
    setOpen: setMenuOpen
  }, handleArchive && /*#__PURE__*/React.createElement(MenuRow, {
    value: archiveLabel || 'Archive',
    selected: false,
    onClick: handleArchive
  }), handleDelete && /*#__PURE__*/React.createElement(MenuRow, {
    value: deleteLabel || 'Delete',
    selected: false,
    onClick: handleDelete
  })));
};
export default NoteTemplateOptionsMenu;